module.exports = __webpack_public_path__ + "static/img/activity_sdy_06-2.385fb01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/surveys/sydney/images/activity/activity_sdy_06-2.jpg
// module id = zvg0
// module chunks = 0